// Six semantic tones — the Guardian light-mode badge palette.
// Lookup values store a token key (green/amber/orange/red/slate/grey).
export const TONES = {
  green: { label: 'Green', text: '#047857', fill: '#ECFDF5', border: '#A7F3D0', dot: '#10B981' },
  amber: { label: 'Amber', text: '#8A6D00', fill: '#FFF8D6', border: '#EFE0A0', dot: '#E0B800' },
  orange: { label: 'Orange', text: '#9A3412', fill: '#FFF1E8', border: '#FBD5BD', dot: '#EA6A20' },
  red: { label: 'Red', text: '#B91C1C', fill: '#FDECEC', border: '#F3C9C9', dot: '#B91C1C' },
  slate: { label: 'Slate', text: '#3D3A35', fill: '#F6F4EF', border: '#DAD5CA', dot: '#6B6660' },
  grey: { label: 'Grey', text: '#6B6660', fill: '#F2F0EA', border: '#E2DED4', dot: '#B5AFA3' },
};
export const TONE_ORDER = ['green', 'amber', 'orange', 'red', 'slate', 'grey'];

const LEGACY = {
  green: 'green', lime: 'green', emerald: 'green', teal: 'green',
  yellow: 'amber', amber: 'amber', orange: 'orange',
  red: 'red', rose: 'red', pink: 'red',
  blue: 'slate', indigo: 'slate', cyan: 'slate', sky: 'slate', purple: 'slate', violet: 'slate',
  gray: 'grey', grey: 'grey', slate: 'slate', zinc: 'grey', stone: 'grey', neutral: 'grey',
};

// Accepts a token key OR a legacy Tailwind class string, returns a tone object.
export const resolveTone = (raw) => {
  if (!raw) return TONES.slate;
  if (TONES[raw]) return TONES[raw];
  const m = String(raw).match(/(?:bg|text)-([a-z]+)-/) || String(raw).match(/([a-z]+)/);
  return TONES[LEGACY[m?.[1]] || 'slate'] || TONES.slate;
};

export const toneKey = (raw) => {
  if (!raw) return 'slate';
  if (TONES[raw]) return raw;
  const m = String(raw).match(/(?:bg|text)-([a-z]+)-/) || String(raw).match(/([a-z]+)/);
  return LEGACY[m?.[1]] || 'slate';
};
